export default "__VITE_ASSET__CL82BiNV__"